/**
 * DenseOverflowLink — the "+N more" affordance on a dense calendar day cell
 * (BON-142). The dense cell has no built-in popover (unlike the default
 * `DayCell`'s `CalendarDayOverflow`); this hands the whole day off to the
 * caller, which opens a day-detail drawer.
 */
export interface DenseOverflowLinkProps {
  hiddenCount: number;
  onClick: () => void;
}

export function DenseOverflowLink({ hiddenCount, onClick }: DenseOverflowLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'block',
        width: '100%',
        textAlign: 'left',
        padding: '1px 6px',
        fontSize: 10,
        fontWeight: 600,
        color: 'var(--nb-primary, #6b8e5a)',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
      }}
    >
      +{hiddenCount} more
    </button>
  );
}
